import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { WkoHighchart } from "../WkoHighchart";
import { WkoLoadingSpinner } from "../WkoLoadingSpinner";
import { notifyError } from "../../utils/notifications";
import { BenchmarkCard } from "./BenchmarkCard";
const LEVEL_COLORS = ["#FAF196", "#F7C245", "#FD6883", "#D87AE7"];
const LEVEL_NAMES = ["NCs Level 1", "NCs Level 2", "NCs Level 3", "NCs Level 4"];
export const LevelsNcPerVesselChart = ({ options, title = "Monthly trends per visit", }) => {
    const [loading, setLoading] = useState(false);
    const [series, setSeries] = useState([]);
    const fleetIds = options.fleet.map((fleet) => fleet.ID).join(",");
    useEffect(() => {
        if (!options.isReady)
            return;
        setSeries([]);
        setLoading(true);
        const params = new URLSearchParams({
            fromMonth: options.startDate.substring(0, 7),
            toMonth: options.endDate.substring(0, 7),
            fleets: fleetIds,
            locationId: options.locationId == null ? "" : String(options.locationId),
        });
        fetch(`/api/levelsbenchmark/ncdayspermonth?${params}`)
            .then((res) => {
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            const levels = [[], [], [], []];
            for (const item of data) {
                if (item.NcLevel < 1 || item.NcLevel > 4)
                    continue;
                levels[item.NcLevel - 1].push([
                    Date.parse(`${item.Month.slice(0, 4)}-${item.Month.slice(4, 6)}`),
                    parseFloat((item.NcDays / item.VesselCount).toFixed(3)),
                    item.NcDays,
                    item.VesselCount,
                ]);
            }
            const nextSeries = levels.map((levelData, index) => ({
                type: "column",
                keys: ["x", "y", "ncdays", "vessels"],
                data: levelData,
                name: LEVEL_NAMES[index],
                color: LEVEL_COLORS[index],
            }));
            setSeries(nextSeries.some((levelData) => levelData.data.length > 0) ? nextSeries : []);
        })
            .catch(() => {
            notifyError("An error has occurred when loading NC levels per vessel data. Please try again.");
        })
            .finally(() => setLoading(false));
    }, [options.isReady, options.startDate, options.endDate, fleetIds, options.locationId]);
    const chartOptions = useMemo(() => ({
        chart: { type: "column", styledMode: false },
        title: { text: undefined },
        exporting: { enabled: false },
        plotOptions: {
            series: {
                dataLabels: { enabled: false },
                marker: { enabled: false },
                tooltip: { dateTimeLabelFormats: { month: "%b-%y" } },
                stacking: "normal",
            },
            column: {
                stacking: "normal",
                dataLabels: { enabled: false },
            },
        },
        xAxis: {
            type: "datetime",
            dateTimeLabelFormats: { month: "%b-%y" },
        },
        yAxis: {
            title: { text: "Average per vessel" },
            stackLabels: { enabled: false },
            reversedStacks: false,
        },
        tooltip: {
            pointFormat: "{series.name}: {point.y} per vessel",
        },
        series,
    }), [series]);
    if (loading) {
        return (_jsx(BenchmarkCard, { title: title, children: _jsx(WkoLoadingSpinner, {}) }));
    }
    if (series.length === 0) {
        return (_jsx(BenchmarkCard, { title: title, children: _jsx("div", { className: "py-5", children: _jsx("p", { className: "text-secondary text-center mb-0", children: "No data for this selection." }) }) }));
    }
    return (_jsx(BenchmarkCard, { title: title, children: _jsx(WkoHighchart, { options: chartOptions }) }));
};
